import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from '../pages/LoginPage.vue';
import HomePage from '../pages/HomePage.vue';
import MesProjets from '../pages/MesProjets.vue';
import CreateProjet from '../pages/CreateProjet.vue';
import CalendrierDesTaches from '../pages/CalendrierDesTaches.vue';

import PublicLayout from '../layouts/publicLayout.vue'
import PrivateLayout from '../layouts/privateLayout.vue'

import { supabase } from '../supabase/client';

const routes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    component: PublicLayout,
    children: [
      { path: '', component: LoginPage }
    ]
  },
  {
    path: '/app',
    component: PrivateLayout,
    children: [
      { path: '', component: HomePage },
      { path: '/mes-projets', component: MesProjets },
      { path: '/calendrier-des-taches', component: CalendrierDesTaches},
      { path: '/create-projet', component: CreateProjet},
      // Tu peux ajouter ici d'autres pages privées plus tard
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Garde d’authentification (placeholder)
router.beforeEach(async (to, from, next) => {
  const { data } = await supabase.auth.getSession()
  const isAuthenticated = !!data.session

  if (to.path.startsWith('/app') && !isAuthenticated) {
    next('/login')
  } else {
    next()
  }
})

export default router
